module.exports = __webpack_public_path__ + "size5.png";